import { useRef, useState } from 'react'
import ConditionalWrapper from '@dustin-web/microsite-components/src/utils/conditional-wrapper'
import { useResponsive, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import Popover from '@dustin-web/microsite-components/src/popover/popover'
import InfoIcon from '@dustin-web/microsite-components/src/icon/generated/info'
import {
  ModalDialog,
  ModalDialogContent,
  ModalDialogHeader,
} from '@dustin-web/microsite-components/src/modal-dialog'
import { PositionType } from '@dustin-web/microsite-components/src/popover'
import React from 'react'

type Props = {
  buttonVariant?: 'text' | 'icon'
  withIcon?: boolean
  headingLevel?: number
  popoverPositions?: PositionType[]
}

export const SearchRankingsInfo = ({
  buttonVariant = 'icon',
  withIcon = true,
  headingLevel = 1,
  popoverPositions = ['bottom-free'],
}: Props) => {
  const { translate } = useTranslations()
  const [popoverOpen, setPopoverOpen] = useState(false)
  const { breakpoints } = useResponsive()
  const buttonRef = useRef<HTMLButtonElement | null>(null)
  const isPopover = breakpoints.min.LG

  return (
    <>
      <button
        ref={buttonRef}
        className="u-border-none u-mb-0 u-pr-0 u-px-8 u-mr-0 u-color-black"
        aria-label={translate('Aria_Label_Search_Logic_Info')}
        onClick={() => setPopoverOpen(!popoverOpen)}>
        {withIcon && <InfoIcon className="i-16 u-mr-8" />}
        {buttonVariant === 'text' && (
          <span className="u-h-16 u-fs-12" style={{ textDecoration: 'underline' }}>
            {translate('Search_Rankings')}
          </span>
        )}
      </button>
      <ConditionalWrapper
        condition={isPopover}
        wrapper={children => (
          <Popover
            open={popoverOpen}
            onToggle={show => setPopoverOpen(show)}
            positions={popoverPositions}
            targetRef={buttonRef}
            content={<>{children}</>}
            popoverClassName="u-col-6"
            layer="header"
            closeOnOutsideClick
          />
        )}
        otherwise={children => (
          <ModalDialog show={popoverOpen} handleClose={() => setPopoverOpen(false)}>
            <ModalDialogHeader title={translate('Search_Rankings')} />
            <ModalDialogContent>{children}</ModalDialogContent>
          </ModalDialog>
        )}>
        {isPopover && (
          <div role="heading" aria-level={headingLevel} className="u-mb-16 h3">
            {translate('Search_Rankings')}
          </div>
        )}
        <div
          dangerouslySetInnerHTML={{
            __html: translate('Search_Rankings_Intro'),
          }}
        />
      </ConditionalWrapper>
    </>
  )
}
